const deleteQuestionsStr = {
  toastrTrue: 'Grupo eliminado',
  toastrFalse: 'Pregunta eliminada',
  txt: 'eliminado con éxito'
};

export default deleteQuestionsStr;
